/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import OtpPanelComponent from "./otpPanel.component";
import { generatePaginationOptions } from "lib/helper";
import messageApi from "app/api/message";
import { useOtpReport } from "modules/otp-report/context/otpReport.context";
import { addAlert } from "modules/notification";
import { useDispatch } from "react-redux";
import { getApiLang } from "app/feature/constants";

function OtpPanelContainer() {
  const {
    setData,
    setPaginationOptions,
    totalRecords,
    setTotalRecords,
    setIsFetching,
    tableFilter,
    setTableFilter,
    lang
  } = useOtpReport();

  const dispatch = useDispatch();

  useEffect(() => {
    setIsFetching(true);
    messageApi.otpReport({
      length: tableFilter.rowsPerPage,
      start: tableFilter.rowsPerPage * tableFilter.page,
      order: tableFilter.order,
      orderBy: tableFilter.orderBy,
      search: tableFilter.search,
      registeredDate: tableFilter.registeredDate
        ? new Date(tableFilter.registeredDate).toISOString()
        : null,
      verifiedDate: tableFilter.verifiedDate
        ? new Date(tableFilter.verifiedDate).toISOString()
        : null
    }).then((response) => {
      setData(response.data.data);
      setTotalRecords(response.data.recordsTotal);
    }).catch((error) => {
      dispatch(
        addAlert({
          severity: "error",
          message: getApiLang(lang, error.code),
        })
      );
    }).finally(() => {
      setIsFetching(false);
    });
  }, [tableFilter]);

  useEffect(() => {
    setPaginationOptions(generatePaginationOptions(totalRecords));
  }, [totalRecords]);

  const handleChangePage = (event, newPage) => {
    let newData = {
      ...tableFilter,
      page: newPage,
    };
    setTableFilter(newData);
  };

  const handleChangeRowsPerPage = (event) => {
    let newData = {
      ...tableFilter,
      page: 0,
      rowsPerPage: event.target.value,
    };
    setTableFilter(newData);
  };

  const handleSearch = (values) => {
    let newData = {
      ...tableFilter,
      page: 0,
      search: values.search,
      registeredDate: values.registeredDate,
      verifiedDate: values.verifiedDate
    };
    setTableFilter(newData);
  };

  const changeOrder = (order, orderBy) => {
    let newData = {
      ...tableFilter,
      order,
      orderBy
    };
    setTableFilter(newData);
  };

  return (
    <OtpPanelComponent
      handleSearch={handleSearch}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      changeOrder={changeOrder}
    />
  );
}

export default OtpPanelContainer;
